import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "prod-line__cover" };
const _hoisted_2 = { class: "prod-line__main" };
const _hoisted_3 = { class: "prod-line__info" };
const _hoisted_4 = { class: "prod-line__brand" };
const _hoisted_5 = {
    key: 0,
    class: "prod-line__name"
};
const _hoisted_6 = { class: "prod-line__offer" };
import Picture from "../../../../components/Picture.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartItemInfo',
    props: {
        item: { type: Object, required: true },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(Picture, {
                        picture: __props.item.image,
                        fill: "",
                        lazy: false
                    }, null, 8 /* PROPS */, ["picture"])
                ]),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.item.brandName), 1 /* TEXT */),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        (__props.item.name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.item.name) + ",", 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(__props.item.offerName), 1 /* TEXT */),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
